exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".separator {\n  border-top: 1px solid #c4c8ca;\n  border-bottom: 1px solid #c4c8ca;\n}\n.contact-picker-info {\n  color: #6e777a;\n  font-size: 14px;\n}\n.w-550 {\n  width: 550px;\n}\n", ""]);
